import { render, staticRenderFns } from "./GravyIndex.vue?vue&type=template&id=283d6978"
import script from "./GravyIndex.vue?vue&type=script&lang=js"
export * from "./GravyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports